/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React, { useContext } from "react";
import classNames from "classnames";
import { useRouter } from "next/router";

import { getCategoryFromId } from "../../../utils/categories";
import { path } from "../../../utils/path";

import Select from "../../form/select";

import styles from "./uiMobile.module.scss";
import { Categorie } from "@/types/categorie";
import { CategoryContext } from "@/hooks/useCategories";
import { SingleValue } from "react-select";

type PropTypes = {
    categoriesHierachy: Categorie[];
    categoryId: number;
    categoryParent: Categorie;
    className?: string;
};

const UiMobile = ({
    categoriesHierachy,
    categoryId,
    categoryParent,
    className = "",
}: PropTypes) => {
    const categories = useContext(CategoryContext);
    const router = useRouter();

    let defaultValueIndex = 0;
    const categoryOptions = [{ value: categoryParent.id, label: "Tous" }];
    categoriesHierachy.forEach((category, index) => {
        const { id, nom } = category;
        categoryOptions.push({ value: id, label: nom });
        if (id === categoryId) {
            defaultValueIndex = index + 1;
        }
    });

    const changeCategoryId = (option: SingleValue<{ value: number; label: string; }>) => {
        const value = option?.value || null;
        if (value) {
            const categoryLink = getCategoryFromId(Number(value), categories);
            if (categoryLink) {
                const categoryParentLinkTo = path.fill(path.CATEGORY, categoryLink);
                router.push(categoryParentLinkTo);
            }
        }
    };

    return (
        <div
            className={classNames(styles.me, {
                [className]: className,
            })}
        >
            <div className={styles.categoryList}>
                {categoryOptions && categoryOptions.length > 1 && (
                    <div className={styles.optionsList}>
                        <Select
                            defaultValue={categoryOptions[defaultValueIndex]}
                            isSearchable
                            onChange={changeCategoryId}
                            options={categoryOptions}
                            singleValue
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default UiMobile;
